// The help centre (/help, src/pages/help) replaces the Intercom Help Center (docs.photohawk.com; owner approved the
// move on 29 Oct 2026, and "Do help centre": live in production, the same day). Where it's off, every /help* URL is
// a real 404, the sitemap leaves it out, the links go to Intercom (HELP_URL) and docs.photohawk.com is not redirected.
//
// Same switch as the guides (src/lib/guidesFlag.ts): the deployment's pinned PHOTOHAWK_ENV, never a visitor's
// override. After this reaches prod, point docs.photohawk.com at the site (docs/help-centre.md).

import { deploymentEnv, type DeploymentEnv } from "./homeFlag";
import { HELP_URL } from "./seo/site";

export const HELP_IN_PROD = true;

/** Where the help centre lives. */
export const HELP_PATH = "/help";

/** Whether the help centre is on for a deployment env. */
export const helpEnabledFor = (env: DeploymentEnv, inProd: boolean = HELP_IN_PROD): boolean => env !== "prod" || inProd;

/** Whether this deployment shows the help centre. */
export const isHelpEnabled = (host?: string): boolean => helpEnabledFor(deploymentEnv(host));

/** The help link for this deployment: /help where it's on, else the Intercom Help Center. */
export const helpHref = (host?: string): string => (isHelpEnabled(host) ? HELP_PATH : HELP_URL);

/** The help centre as an absolute URL on the marketing apex, for pages served on other hosts (the admin on a
 *  workspace's own domain): https://photohawk.com/help where it's on, else the Intercom Help Center. */
export const helpCentreUrl = (host?: string): string => {
  const env = deploymentEnv(host);
  if (!helpEnabledFor(env)) return HELP_URL;
  return `${env === "prod" ? "https://photohawk.com" : "https://photohawk-staging.com"}${HELP_PATH}`;
};
